import config  from '../config';
import { showStaticDevice } from "../common";
import { setSectionNumber } from "./section-indicators";
import { setSpriteOnCanvas } from "../common";

const firefoxAgent = navigator.userAgent.indexOf("Firefox") > -1;

const deviceCanvas = document.getElementById(
  "device-canvas"
) as HTMLCanvasElement;
const deviceContext = deviceCanvas.getContext("2d");

export function showScene2Slices(){
  const scene2Slices = document.getElementById("scene-2-slices-container");
  scene2Slices.classList.add('active');
}

export function hideScene2Slices() {
  const scene2Slices = document.getElementById("scene-2-slices-container");
  scene2Slices.classList.remove("active");
}

export default function () {
  const scene = config['scene-2'];

  const tlIntro = gsap.timeline({
    scrollTrigger: {
      id: "scene-2-intro",
      trigger: "#scene-2-intro",
      start: function(){
        if (config.mobileLayout){
          return `top bottom-=${
            config.pinLocationMobile
          }`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: `+=${100}`,
      pin: true,
      pinSpacing: true,
      onEnter: () => {
        showStaticDevice();
        setSectionNumber(2);
      },
      scrub: true,
      // markers: true,
    },
  });
  tlIntro.addLabel('start');
  tlIntro.to(
    "#PageContainer",
    {
      background: "#F1F1F1",
      duration: 1,
    },
    "start"
  );


  // Play scene-2 frames
  const tlExplode = gsap.timeline({
    scrollTrigger: {
      id: `scene-2-explode`,
      trigger: "#scene-2-explode",
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: function () {
        if (config.mobileLayout) {
          return `+=${config.scrollSpanMobile / 2}`;
        }
        return `+=${config.scrollSpan}`;
      },
      pin: false,
      pinSpacing: false,
      scrub: true,
      // markers: true,
      onLeaveBack: showStaticDevice,
      onUpdate: (self) => {
        let frameNumber = Math.floor(self.progress * scene.maxFrameIndex);
        setSpriteOnCanvas({
          context: deviceContext,
          targetFrameIndex: frameNumber,
          spriteSettings: scene.sprites,
        });
      },
    },
  });

  const tlFadeOutCanvas = gsap.timeline({
    scrollTrigger: {
      id: "scene-2-fade-out-canvas",
      trigger: "#scene-2-specs",
      start: function () {
        if (config.mobileLayout) {
          return `top bottom-=${config.pinLocationMobile}`;
        }
        return `top center+=${config.pinTextOffset}`;
      },
      end: function () {
        if (config.mobileLayout) {
          return `+=${config.scrollSpanMobile / 2}`;
        }
        return `+=${config.scrollSpan / 2}`;
      },
      scrub: true,
      onEnter: showScene2Slices,
      onLeaveBack: hideScene2Slices,
      // markers: true,
    },
  });
  tlFadeOutCanvas.to("#device-canvas", {
    duration: 1,
    autoAlpha: 0,
  });


  const specs = gsap.utils.toArray("#scene-2 .spec");
  const lastSpecIndex = specs.length - 1;
  specs.forEach((spec: HTMLElement, index) => {
    const specType = spec.dataset.specType;
    const slices = gsap.utils.toArray(
      `#scene-2-slices-container img[data-spec-type="${specType}"]`
    );
    const notSlices = gsap.utils.toArray(
      `#scene-2-slices-container img:not([data-spec-type="${specType}"])`
    );

    if (index < lastSpecIndex) {

      const tlKeyframe = gsap.timeline({
        scrollTrigger: {
          id: `${scene.id}-${index + 1}-keyframe`,
          trigger: spec,
          start: firefoxAgent
            ? `top center+=${config.pinTextOffset}`
            : `top-=${config.scrollSpan} center+=${config.pinTextOffset}`,
          end: firefoxAgent ? 1 : `+=${config.scrollSpan}`,
          // start: `top-=${config.scrollSpan} center+=${config.pinTextOffset}`,
          // end: `+=${config.scrollSpan}`,
          pin: false,
          scrub: firefoxAgent ? false : true,
          // scrub: true,
          onEnterBack: () => {
            if (firefoxAgent) {
              gsap.set(slices, {
                opacity: 1,
                onStart: () => {
                  console.log("onEnterBack SET ACTIVE", specType, slices);
                },
              });
              gsap.set(notSlices, {
                opacity: 0.18,
                onStart: () => {
                  console.log("onEnterBack UNSET ACTIVE", specType, notSlices);
                },
              });
            }
          },
          // markers: true,
        },
      });
      tlKeyframe.addLabel('start');
      tlKeyframe[firefoxAgent ? 'set' : 'to'](
      // tlKeyframe.to(
        slices,
        {
          duration: firefoxAgent ? 0 : 1,
          opacity: 1,
          ease: Sine.easeInOut,
          onStart: () => {
            console.log("SET ACTIVE", specType, slices);
          },
        },
        "start"
      );
      tlKeyframe[firefoxAgent ? "set" : "to"](
        // tlKeyframe.to(
        notSlices,
        {
          duration: firefoxAgent ? 0 : 1,
          opacity: 0.18,
          ease: Sine.easeInOut,
          onStart: () => {
            console.log("UNSET ACTIVE", specType, notSlices);
          },
        },
        "start"
      );
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        id: `scene-2-spec-${index + 1}-text`,
        trigger: spec,
        start: `top center+=${config.pinTextOffset}`,
        end: `+=${config.scrollSpan * 2}`,
        pin: true,
        pinSpacing: false,
        anticipatePin: 1,
        // markers: true,
        onEnter: function () {
          console.log("SCENE 2 SPEC ENTER", specType, slices, notSlices);
        },
        onLeave: function () {
          console.log("SCENE 2 SPEC LEAVE", specType, slices, notSlices);
        },
        // markers: index === lastSpecIndex
      },
    });
    tl.addLabel("start");
    tl.from(
      spec,
      {
        duration: 1,
        y: config.scrollSpan,
        autoAlpha: 0,
        ease: Sine.easeInOut,
      },
      "start"
    );
    tl.addLabel("land", `+=.5`);
    tl.to(
      spec,
      {
        duration: 0.5,
        y: -config.scrollSpan / 2,
        autoAlpha: 0,
        ease: Sine.easeInOut,
      },
      "land"
    );
  });

  const fadeInEndSpan = 200;
  const tlEndDeviceFade = gsap.timeline({
    scrollTrigger: {
      id: "scene-2-end-start",
      trigger: "#scene-2-device-fade-in",
      start: `top center+=${config.pinTextOffset}`,
      end: `+=${fadeInEndSpan}`,
      scrub: true,
      // markers: true,
      onLeaveBack: () => {
        gsap.to("#device-canvas", 1, {
          autoAlpha: 0,
        });
      },
    },
  });
  tlEndDeviceFade.addLabel("start");
  tlEndDeviceFade.to(
    "#device-canvas",
    {
      autoAlpha: 1,
      duration: 1,
    },
    "start"
  );

  const tlEndUnexplode = gsap.timeline({
    scrollTrigger: {
      id: "scene-2-end-unexplode",
      trigger: "#scene-2-unexplode",
      start: `top center+=${config.pinTextOffset - fadeInEndSpan}`,
      end: `+=${config.scrollSpan - fadeInEndSpan}`,
      // markers: true,
      onEnter: hideScene2Slices,
      onLeaveBack: showScene2Slices,
      onEnterBack: () => {
        setSectionNumber(2);
        gsap.to(
          "#PageContainer",
          {
            background: "#F1F1F1",
            duration: .5,
          },
        );
      },
      scrub: true,
      onUpdate: (self) => {
        let frameNumber = Math.floor(self.progress * scene.maxFrameIndex);
        // Play the explosion in reverse.
        frameNumber = scene.maxFrameIndex - frameNumber;
        if (frameNumber > scene.maxFrameIndex) {
          frameNumber = scene.maxFrameIndex;
        } else if (frameNumber < 0) {
          frameNumber = 0;
        }
        setSpriteOnCanvas({
          context: deviceContext,
          targetFrameIndex: frameNumber,
          spriteSettings: scene.sprites,
        });
      },
    },
  });
}
